export const CREATING_TRIBE_TEMPLATE = 'Creating Tribe Template';
export const RETRIEVING_TRIBE_TEMPLATE = 'Retrieving Tribe Template';
export const UPDATING_TRIBE_TEMPLATE = 'Updating Tribe Template';
